module.exports = __webpack_public_path__ + "img/smart-living.ef589755.jpg";